import React from 'react';

import { HashRouter as Router, Switch, Redirect, Route } from 'react-router-dom';
import Loadable from 'react-loadable';

const Main = Loadable({
    loader: () => import('./../main'),
    loading: () => (<label>Loading...</label>)
});

const Admin = Loadable({
    loader: () => import('./../admin/route'),
    loading: () => (<label>Loading...</label>)
});

const Review = Loadable({
    loader: () => import('./../testimonials/form/container'),
    loading: () => (<label>Loading...</label>)
});

const homeRoutes  = [
    '/home', '/services', '/testimonials',
    '/faq', '/aboutUs', '/contactUs', '/careers'
];

const Application = Loadable({
    loader: () => import('./../careers/form/container'),
    loading: () => (<label>Loading...</label>)
});

const AppRoute = () => {
    return (
        <Router hashType = 'noslash'>
            <Switch>
                <Redirect exact strict from='/' to='/home'/>
                <Route path = { homeRoutes } component = {Main} />
                <Route path = '/admin' component = {Admin} />
                <Route path = '/review' component = {Review} />
                <Route path = '/apply' component = {Application} />
                {/* <AuthRoute path='/lgn' component = {Admin}/> */}
            </Switch>
        </Router>
    );
}

export default AppRoute;